<template>
  <div class="historySearch">
    <div class="header">
      <h3>历史搜索</h3>
      <span @click="deleHistory" v-if="searchHisList.length">删除</span>
    </div>
    <ul>
      <li v-for="(item, index) in searchHisList" :key="index">{{item}}</li>
    </ul>
  </div>
</template>

<script>
import { searchHistory } from "@/utils/storage";
import { Notify } from "vant";
export default {
  data() {
    return {
      value: ""
    }
  },
  components: {
    [Notify.name]: Notify
  },
  computed: {
    searchHisList() {
      let arr = this.$store.state.SearchHistory.filter((ele, index, self) => {
        return self.indexOf(ele) === index
      })
      return arr.slice(0, 8);
    }
  },
  methods: {
    deleHistory() {
      this.$store.dispatch("ChangeVmSearch", []);
      this.$emit("deleHis");
      searchHistory("searchHistory", []);
      Notify({
        message: "删除成功",
        duration: 1000,
        background: "#1989fa"
      });
    }
  }
}
</script>

<style scoped lang="less">
.historySearch {
  flex: 1;
  width: 100%;
  height: auto;
  // height: 300px;
  padding: 17px 20px 24px 20px;
  box-sizing: border-box;
  background: #fff;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(236, 233, 233, 1);
    padding-bottom: 20px;
    margin-bottom: 15px;
    & > h3 {
      font-size: 14px;
      font-weight: 500;
      color: rgba(41, 41, 41, 1);
    }
    & > span {
      font-weight: 400;
      color: #686767;
      font-size: 12px;
    }
  }
  & > ul {
    width: 100%;
    height: auto;
    li {
      border-bottom: 1px solid rgba(236, 233, 233, 1);
      padding-bottom: 18px;
      margin-bottom: 19px;
      font-weight: 400;
      color: rgba(104, 103, 103, 1);
      font-size: 14px;
    }
  }
}
</style>
